import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SEB_TEST_DATA } from '../../data/sebTestData';

const Question = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const questionId = parseInt(id);
    const question = SEB_TEST_DATA.questions.find(q => q.id === questionId);

    const [answers, setAnswers] = useState(() => {
        const saved = localStorage.getItem('sebTestAnswers');
        return saved ? JSON.parse(saved) : {};
    });

    useEffect(() => {
        if (!question) {
            navigate('/seb-test');
        }
    }, [question, navigate]);

    if (!question) return null;

    const progress = (questionId / SEB_TEST_DATA.questions.length) * 100;

    const handleAnswer = (index) => {
        const newAnswers = { ...answers, [questionId]: index };
        setAnswers(newAnswers);
        localStorage.setItem('sebTestAnswers', JSON.stringify(newAnswers));

        if (questionId < SEB_TEST_DATA.questions.length) {
            navigate(`/seb-test/q/${questionId + 1}`);
        } else {
            navigate('/seb-test/loading');
        }
    };

    return (
        <div className="question-container">
            <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${progress}%` }}></div>
            </div>

            <div className="question-card">
                <span className="q-number">Question {questionId} of {SEB_TEST_DATA.questions.length}</span>
                <h2 className="question-text">{question.q}</h2>

                <div className="options-grid">
                    {question.a.map((option, index) => (
                        <button
                            key={index}
                            className="option-btn"
                            onClick={() => handleAnswer(index)}
                        >
                            {option}
                        </button>
                    ))}
                </div>
            </div>

            <style jsx>{`
                .question-container {
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    background: #0f172a;
                    padding: 1.5rem;
                }

                .progress-bar {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 6px;
                    background: rgba(255, 255, 255, 0.1);
                    z-index: 100;
                }

                .progress-fill {
                    height: 100%;
                    background: linear-gradient(90deg, #3b82f6, #8b5cf6);
                    transition: width 0.3s ease;
                }

                .question-card {
                    width: 100%;
                    max-width: 600px;
                    background: rgba(255, 255, 255, 0.05);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 24px;
                    padding: 2.5rem;
                    box-shadow: 0 20px 40px rgba(0,0,0,0.3);
                }

                .q-number {
                    color: #64748b;
                    font-size: 0.9rem;
                    font-weight: 600;
                    display: block;
                    margin-bottom: 1rem;
                }

                .question-text {
                    color: white;
                    font-size: 1.5rem;
                    line-height: 1.6;
                    margin-bottom: 2.5rem;
                    word-break: keep-all;
                }

                .options-grid {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }

                .option-btn {
                    width: 100%;
                    padding: 1.2rem 1.5rem;
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 16px;
                    color: #cbd5e1;
                    font-size: 1rem;
                    text-align: left;
                    cursor: pointer;
                    transition: all 0.2s;
                    line-height: 1.5;
                }

                .option-btn:hover {
                    background: rgba(59, 130, 246, 0.1);
                    border-color: #3b82f6;
                    color: white;
                    transform: translateX(4px);
                }

                @media (max-width: 480px) {
                    .question-card {
                        padding: 1.5rem;
                    }
                    .question-text {
                        font-size: 1.25rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default Question;
